import React, { useEffect, useState } from 'react'; // custom modification
import { Translate, translate, ValidatedField } from 'react-jhipster';
import { Alert, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'react-bootstrap';
import { Link } from 'react-router';
import { type FieldError, useForm } from 'react-hook-form';
import { ICompany } from 'app/shared/model/company.model';
import { IBranchMaster } from 'app/shared/model/branch-master.model';

export interface ILoginModalProps {
  showModal: boolean;
  loginError: boolean;
  handleLogin: (username: string, password: string, companyId: string, branchId: string, rememberMe: boolean) => void;
  handleClose: () => void;
  companies: ReadonlyArray<ICompany>;
  branches: ReadonlyArray<IBranchMaster>;
  onChangeCompany: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showCompanyAndBranch?: boolean;
}

const LoginModal = (props: ILoginModalProps) => {
  const login = ({ username, password, rememberMe }) => {
    props.handleLogin(username, password, company.toString(), branch.toString(), rememberMe);
  };

  const {
    handleSubmit,
    register,
    formState: { errors, touchedFields },
  } = useForm({ mode: 'onTouched' });

  const { loginError, handleClose, companies, branches, onChangeCompany } = props;

  const [company, setCompany] = useState(0);
  const [branch, setBranch] = useState(0);

  useEffect(() => {
    if (branches.length !== 0) {
      setBranch(branches[0].id);
    }
  }, [branches]);

  useEffect(() => {
    if (companies.length !== 0) {
      setCompany(companies[0].id);
    }
  }, [companies]);

  const handleLoginSubmit = e => {
    handleSubmit(login)(e);
  };

  return (
    <Modal show={props.showModal} onHide={handleClose} backdrop="static" id="login-page" autoFocus={false}>
      <Form onSubmit={handleLoginSubmit}>
        <ModalHeader id="login-title" data-cy="loginTitle" closeButton onHide={handleClose}>
          <Translate contentKey="login.title">Sign in</Translate>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              {loginError ? (
                <Alert variant="danger" data-cy="loginError">
                  <Translate contentKey="login.messages.error.authentication">
                    <strong>Failed to sign in!</strong> Please check your credentials and try again.
                  </Translate>
                </Alert>
              ) : null}
            </Col>
            <Col md="12">
              <ValidatedField
                name="username"
                label={translate('global.form.username.label')}
                placeholder={translate('global.form.username.placeholder')}
                required
                autoFocus
                data-cy="username"
                validate={{ required: 'Username cannot be empty!' }}
                register={register}
                error={errors.username as FieldError}
                isTouched={touchedFields.username}
              />
              <ValidatedField
                name="password"
                type="password"
                label={translate('login.form.password')}
                placeholder={translate('login.form.password.placeholder')}
                required
                data-cy="password"
                validate={{ required: 'Password cannot be empty!' }}
                register={register}
                error={errors.password as FieldError}
                isTouched={touchedFields.password}
              />
              {props.showCompanyAndBranch && (
                <>
                  <ValidatedField
                    name="companyId"
                    type="select"
                    label={translate('login.form.company')}
                    value={company}
                    onChange={e => {
                      setCompany(Number(e.target.value));
                      // react-jhipster types select fields' onChange as a generic FormControl event even though this renders a <select>
                      onChangeCompany(e as unknown as React.ChangeEvent<HTMLInputElement>);
                    }}
                  >
                    {companies.map(item => (
                      <option value={item.id} key={item.id}>
                        {item.id} - {item.description}
                      </option>
                    ))}
                  </ValidatedField>
                  <ValidatedField
                    name="branchId"
                    type="select"
                    label={translate('login.form.branch')}
                    value={branch}
                    onChange={e => setBranch(Number(e.target.value))}
                  >
                    {branches.map(item => (
                      <option value={item.id} key={item.id}>
                        {item.id} - {item.description}
                      </option>
                    ))}
                  </ValidatedField>

                  <ValidatedField
                    name="rememberMe"
                    type="checkbox"
                    check
                    label={translate('login.form.rememberme')}
                    value={true}
                    register={register}
                  />
                </>
              )}
            </Col>
          </Row>
          <div className="mt-1">&nbsp;</div>
          <Alert variant="warning">
            <Link to="/account/reset/request" data-cy="forgetYourPasswordSelector">
              <Translate contentKey="login.password.forgot">Did you forget your password?</Translate>
            </Link>
          </Alert>
          <Alert variant="warning">
            <span>
              <Translate contentKey="global.messages.info.register.noaccount">You don&apos;t have an account yet?</Translate>
            </span>{' '}
            <Link to="/account/register">
              <Translate contentKey="global.messages.info.register.link">Register a new account</Translate>
            </Link>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={handleClose} tabIndex={1}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>{' '}
          <Button variant="primary" type="submit" data-cy="submit">
            <Translate contentKey="login.form.button">Sign in</Translate>
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default LoginModal;
